import { useMutation } from '@tanstack/react-query';

import { socialApiClient } from '@/shared/api-client/social-api-client';

// API Request/Response types based on OpenAPI spec
interface WorkspaceCreateRequest {
  name: string;
  language: string;
  timezone: string;
}

interface WorkspaceCreateResponse {
  id: string;
  name: string;
  language: string;
  timezone: string;
}

async function createWorkspace(payload: {
  workspaceName: string;
  language: string;
  timezone: string;
}): Promise<WorkspaceCreateResponse> {
  const response = await socialApiClient.post('workspaces', {
    json: {
      name: payload.workspaceName,
      language: payload.language,
      timezone: payload.timezone,
    } satisfies WorkspaceCreateRequest,
  });

  return response.json<WorkspaceCreateResponse>();
}

export function useCreateWorkspace() {
  return useMutation({
    mutationFn: createWorkspace,
  });
}
